import {
    SET_IS_FETCHING_USER_ADDRESSES,
    SET_IS_UPDATING_ADDRESS,
    SET_ORDER_ADDRESS,
    SET_USER_ADDRESSES,
    SET_DEFAULT_ADDRESS,
} from 'reducers/actions-types';


export default function cartReducer(state = {
    address_id: null,
    addresses: [],
    isFetchingAddresses: false,
    isUpdatingAddresses: false,
}, {
    type,
    addresses,
    addressId,
    isFetchingAddresses,
    isUpdatingAddresses,
}) {
    switch (type) {
        case SET_ORDER_ADDRESS:
            return Object.assign({}, state, { address_id: addressId });
        case SET_DEFAULT_ADDRESS:
            return Object.assign({}, state, { address_id: addressId });
        case SET_USER_ADDRESSES:
            return Object.assign({}, state, { addresses: [...addresses] });
        case SET_IS_FETCHING_USER_ADDRESSES:
            return Object.assign({}, state, {
                isFetchingAddresses,
            });
        case SET_IS_UPDATING_ADDRESS:
            return Object.assign({}, state, {
                isUpdatingAddresses,
            });
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/address/index.js